import { toast } from 'react-toastify';
import { Spinner } from '@ds';
import { Form } from '@ui';
import { useAuthContext } from '@lp/core/auth';
import { SchedulerSettingsSubmitRow } from '@lp/features/Scheduler/components';
import { OMSSchedulerSettingsInputsFormType } from '@lp/features/Scheduler/SchedulerOMSSettings/types';
import { OMSSchedulerSettingsInputsForm } from '@lp/features/Scheduler/SchedulerOMSSettings/components';
import {
  omsSchedulerSettingsInputsFormSchema,
  getDefaultOMSSchedulerInputsValues,
  getOMSSchedulerInputsSettingsFromForm,
} from '@lp/features/Scheduler/SchedulerOMSSettings/config';
import {
  useOMSScheduleSettingsInputsQuery,
  useOMSSetScheduleSettingsInputsMutation,
} from '@/queries/resource/schedule';
import { retrieveUnifiedError } from '@/api/utils';
import { SchedulerPermissions } from '@/permissions';

export const OMSSchedulerSettingsInputsTab = () => {
  const { checkPermission } = useAuthContext();
  const { data: schedulerSettingsInputs } = useOMSScheduleSettingsInputsQuery();
  const { mutateAsync, isPending } = useOMSSetScheduleSettingsInputsMutation();

  const hasWritePermissions = checkPermission(SchedulerPermissions.OMSSchedulesSettingsInputsWrite);

  const handleSubmit = async (data: OMSSchedulerSettingsInputsFormType) => {
    try {
      const body = getOMSSchedulerInputsSettingsFromForm(data);
      await mutateAsync(body);
      toast.success(`Scheduler Inputs updated successfully`);
    } catch (e) {
      const error = retrieveUnifiedError(e);
      toast.error(error.message);
    }
  };

  if (!schedulerSettingsInputs) {
    return <Spinner />;
  }

  return (
    <Form<OMSSchedulerSettingsInputsFormType>
      defaultValues={getDefaultOMSSchedulerInputsValues(schedulerSettingsInputs)}
      schema={omsSchedulerSettingsInputsFormSchema}
      onSubmit={handleSubmit}
    >
      <OMSSchedulerSettingsInputsForm isReadOnly={!hasWritePermissions} />
      <SchedulerSettingsSubmitRow backPath="/schedule/oms" isLoading={isPending} isReadOnly={!hasWritePermissions} />
    </Form>
  );
};
